import {
  Locale,
  format,
  formatDistance,
  formatRelative,
  isDate,
} from "date-fns";
import { enUS } from "date-fns/locale";

import enTranslation from "../locales/en.json";

const en: Locale = {
  ...enUS,
  formatRelative: (token, date, baseDate, options) => {
    if (enTranslation?.dateFnsOverrides?.formatRelative?.[token]) {
      return enTranslation.dateFnsOverrides.formatRelative[token];
    }
    return enUS.formatRelative(token, date, baseDate, options);
  },
};

const locales = { en };

const getLocale = (lng?: string) => {
  if (lng && lng in locales) {
    return locales[lng as keyof typeof locales];
  }
  return enUS;
};

export const formatShortDate = (date: Date, lng?: string) => {
  const locale = getLocale(lng);
  return format(date, "P", { locale });
};

export const formatShortWeekDay = (date: Date, lng?: string) => {
  const locale = getLocale(lng);
  return format(date, "EEE", { locale });
};

export const formatLongDate = (
  date: Date,
  lng?: string,
  options?: { hideWeekday?: boolean; hideYear?: boolean },
) => {
  const locale = getLocale(lng);
  const { hideWeekday = false, hideYear = false } = options || {};
  return format(
    date,
    `${hideWeekday ? "" : "EEEE, "}MMMM d${hideYear ? "" : ", yyyy"}`,
    {
      locale,
    },
  );
};

export const formatRelativeDate = (date: Date, lng?: string) => {
  const locale = getLocale(lng);
  return formatRelative(date, new Date(), { locale });
};

export const formatTime = (date: Date, lng?: string) => {
  const locale = getLocale(lng);
  return format(date, "p", { locale });
};

export const formatTimeSeconds = (date: Date, lng?: string) => {
  const locale = getLocale(lng);
  return format(date, "pp", { locale });
};

export const formatTimeAgo = (date: Date, lng?: string) => {
  const locale = getLocale(lng);
  return formatDistance(date, new Date(), { locale });
};

export { isDate };
